<template>
    <div class="cabinet-content-wrap">
        <header class="cabinet-header flex flex-align-center">
            <a
                href="#"
                class="cabinet-btn--back cabinet-btn--back-list"
                @click.prevent="$router.go(-1)"
            ></a>
            <h1 class="h1 cabinet-title d-none d-md-block">
                {{ list.ListName }}
            </h1>
            <button
                type="button"
                class="cabinet-btn cabinet-btn--default ml-auto d-none d-lg-block"
                @click="openModal('RemoveList', list)"
            >
                Удалить список
            </button>
            <button
                type="button"
                class="cabinet-btn-icon cabinet-btn-icon--default cabinet-btn-icon--trash ml-auto d-lg-none"
                @click="openModal('RemoveList', list)"
            ></button>

            <button
                type="button"
                class="cabinet-btn ml-3 d-none d-lg-block"
                @click="addAllItemsInCart(list)"
            >
                Добавить все изделия в корзину
            </button>
            <button
                type="button"
                class="cabinet-btn ml-3 d-lg-none"
                @click="addAllItemsInCart(list)"
            >
                В корзину
            </button>
        </header>
        <h1 class="h1 cabinet-title mt-0 mb-0 pb-4 d-md-none">
            {{ list.ListName }}
        </h1>

        <section class="cabinet-section cabinet-table catalog-content">
            <retailer-product-list
                :page-sizes="[16, 32, 48, 60]"
                :sort="['Name:asc', 'Name:dsc', 'Price:asc', 'Price:dsc']"
                :lists="[currentListID]"
                for-list
            />
        </section>

        <remove-list-modal
            :is-open="isRemoveListModalOpened"
            :list="list"
            @onConfirm="removeList(list)"
            @onClose="closeModal('RemoveList', list)"
        />
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import jq from '@/mixins/jq'
import modal from '@/mixins/modal'
import checkDemoUser from '@/mixins/checkDemoUser.js'

import RetailerProductList from '@/components/Cabinet/Retailer/ProductList'
import RemoveListModal from '../../../components/Cabinet/Retailer/Lists/RemoveListModal'

export default {
    name: 'RetailerList',
    components: { RemoveListModal, RetailerProductList },
    mixins: [jq, modal, checkDemoUser],
    data() {
        return {
            currentListID: parseInt(this.$route.params.id, 10),
            isRemoveListModalOpened: false
        }
    },
    computed: {
        ...mapGetters('retailerLists', ['list'])
    },
    created() {
        this.getList()
    },
    methods: {
        ...mapActions('retailerLists', {
            getListItem: 'getListItem',
            removeRetailerList: 'removeList'
        }),
        ...mapActions('cart', ['addAllItemsFromList']),
        getList() {
            this.$Progress.start()

            this.getListItem(this.currentListID).finally(() => {
                this.$Progress.finish()
            })
        },
        removeList({ ListID, ListName }) {
            if (this.isDemoUserMode()) return

            this.$Progress.start()
            this.removeRetailerList(ListID)
                .then(() => {
                    this.$notify({
                        title: `Список ${ListName} удален`,
                        type: 'default'
                    })

                    this.closeModal('RemoveList')
                    this.$router.replace('/account/lists')
                })
                .finally(() => {
                    this.$Progress.finish()
                })
        },
        addAllItemsInCart({ ListID, ListName }) {
            if (this.isDemoUserMode()) return

            this.$Progress.start()

            this.addAllItemsFromList(ListID)
                .then(() => {
                    this.$notify({
                        title: `Изделия из списка ${ListName} добавлены в корзину`,
                        type: 'success'
                    })
                })
                .finally(() => {
                    this.$Progress.finish()
                })
        }
    }
}
</script>
